import { Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, Box, ThemeProvider, GlobalStyles } from '@mui/material';
import theme from './theme/theme';
import Header from './components/layouts/Header';
import Footer from './components/layouts/Footer';
import MonthEndSettlement from './pages/settlement/MonthEndSettlement';
import SspSettlement from './pages/settlement/SspSettlement';
import Pointhome from './pages/pointhome/Pointhome';
import PointhomeSettlementStatus from './pages/pointhome/settlementStatus/PointhomeSettlementStatus';
import PointhomeProfitLoss from './pages/pointhome/contents/PointhomeProfitLoss';
import Buzzvil from './pages/pointhome/buzzvil/Buzzvil';
import Offerwall from './pages/pointhome/offerwall/Offerwall';
import MoneyArcade from './pages/pointhome/moneyArcade/MoneyArcade';
import ContentsArcade from './pages/pointhome/contentsArcade/ContentsArcade';
import Harustory from './pages/pointhome/harustory/Harustory';
import AdPopcorn from './pages/pointhome/adpopcorn/AdPopcorn';
import AdPopcornDetail from './pages/pointhome/adpopcorn/AdPopcornDetail';
import AceEnter from './pages/pointhome/aceenter/AceEnter';
import PointhomeRetention from './pages/pointhome/analytics/PointhomeRetention';
import WelcomeRetention from './pages/pointhome/analytics/WelcomeRetention';
import PointhomeParticipation from './pages/pointhome/contents/PointhomeParticipation';
import PointhomeContentStatus from './pages/pointhome/contents/PointhomeContentStatus';
import AdcashBuzzvil from './pages/adcash/buzzvil/AdcashBuzzvil';
import AdcashGuruNAMApp from './pages/adcash/guru/nam/GuruNAMApp';
import AdcashGuruNAMWeb from './pages/adcash/guru/nam/GuruNAMWeb';
import AdcashGuruAdforus from './pages/adcash/guru/adforus/GuruAdforus';
import AdcashGuruTargetPick from './pages/adcash/guru/targetpick/GuruTargetPick';
import AdcashGuruCovi from './pages/adcash/guru/covi/GuruCovi';
import AdcashAvatyeRevenue from './pages/adcash/avatye/AdcashAvatyeRevenue';
import AdcashAvatyeDetail from './pages/adcash/avatye/detail/AdcashAvatyeDetail';
import Adfit from './pages/adcash/adfit/Adfit';

import NaverProviderRevenue from './pages/naver/NaverProviderRevenue';
import NaverDirectDetailStats from './pages/naver/NaverDirectDetailStats';
import NaverSpentStats from './pages/naver/NaverSpentStats';
import NaverDirectRealtimeStats from './pages/naver/NaverDirectRealtimeStats';
import NewsRevenue from './pages/naver/NewsRevenue';
import NewsMagazineStats from './pages/naver/NewsMagazineStats';
import NewsDirectRealtimeStats from './pages/naver/NewsDirectRealtimeStats';

import RouletteChart from './pages/pointhome/roulette/chart/RouletteChart';
import RouletteRevenue from './pages/pointhome/roulette/revenue/RouletteRevenue';
import RouletteContent from './pages/pointhome/roulette/content/RouletteContent';
import RouletteRetention from './pages/pointhome/roulette/retention/RouletteRetention';
import DeadClickLab from './pages/pointhome/experiment/DeadClickLab';
import TicketReceived from './pages/lucky-lottery/ticket/TicketReceived';
import ContentsParticipation from './pages/lucky-lottery/ticket/ContentsParticipation';
import AttendanceCheck from './pages/lucky-lottery/ticket/AttendanceCheck';
import EnterCount from './pages/lucky-lottery/enter/EnterCount';
import LuckyLotteryExchange from './pages/lucky-lottery/exchange/LuckyLotteryExchange';
import LuckyLotteryNpayExchange from './pages/lucky-lottery/exchange/LuckyLotteryNpayExchange';
import LuckyLotteryAdPopcorn from './pages/lucky-lottery/adpopcorn/AdPopcorn';
import LuckyLotteryAdPopcornDetail from './pages/lucky-lottery/adpopcorn/AdPopcornDetail';
import LuckyLotteryRevenue from './pages/lucky-lottery/revenue/LuckyLotteryRevenue';
import LuckyLotteryRevenueDetail from './pages/lucky-lottery/revenue/LuckyLotteryRevenueDetail';
import LuckyLotterySettlementStatus from './pages/lucky-lottery/settlementStatus/LuckyLotterySettlementStatus';
import LuckyLotteryBuzzvil from './pages/lucky-lottery/buzzvil/Buzzvil';
import LuckyLotteryRetention from './pages/lucky-lottery/retention/LuckyLotteryRetention';
import LuckyLotteryWinning from './pages/lucky-lottery/winning/LuckyLotteryWinning';

import LoginWithMS from './pages/login/LoginWithMS';
import LoginGuest from './pages/login/LoginGuest';
import ProtectedRoute from './components/auth/ProtectedRoute';

const ENV = process.env.REACT_APP_ENV || 'dev';
const isProd = ENV === 'prod';

export default function App() {
  const mainLayout = (
    <Box display="flex" flexDirection="column" minHeight="100vh" bgcolor="#f8fafc">
      <Header />

      <Box
        component="main"
        sx={{
          flex: 1,
          px: 3,
          pt: 3,
          pb: { xs: 2, md: 3 },
          mt: '64px',
          bgcolor: '#f8fafc',
        }}
      >
        <Routes>
          <Route path="/settlement/rc" element={<MonthEndSettlement />} />
          <Route path="/settlement/ssp" element={<SspSettlement />} />
          <Route path="/" element={<Navigate to="/pointhome" replace />} />
          <Route path="/pointhome" element={<Pointhome />} />
          <Route path="/pointhome/settlement/status" element={<PointhomeSettlementStatus />} />
          <Route path="/pointhome/content/metrics/profit-loss" element={<PointhomeProfitLoss />} />
          <Route
            path="/pointhome/content/metrics/participation"
            element={<PointhomeParticipation />}
          />
          <Route path="/pointhome/content/metrics/status" element={<PointhomeContentStatus />} />
          <Route path="/pointhome/adpopcorn" element={<AdPopcorn />} />
          <Route path="/pointhome/adpopcorn/detail" element={<AdPopcornDetail />} />
          <Route path="/pointhome/buzzvil" element={<Buzzvil />} />
          <Route path="/pointhome/offerwall" element={<Offerwall />} />
          <Route path="/pointhome/moneyArcade" element={<MoneyArcade />} />
          <Route path="/pointhome/contentsArcade" element={<ContentsArcade />} />
          <Route path="/pointhome/harustory" element={<Harustory />} />
          <Route path="/pointhome/aceenter" element={<AceEnter />} />
          <Route path="/pointhome/user/metrics/retention" element={<PointhomeRetention />} />
          <Route path="/pointhome/user/metrics/welcome/retention" element={<WelcomeRetention />} />
          <Route path="/pointhome/roulette/chart" element={<RouletteChart />} />
          <Route path="/pointhome/roulette/revenue" element={<RouletteRevenue />} />
          <Route path="/pointhome/roulette/content" element={<RouletteContent />} />
          <Route path="/pointhome/roulette/retention" element={<RouletteRetention />} />
          <Route path="/pointhome/dead-click" element={<DeadClickLab />} />
          <Route path="/adcash/buzzvil" element={<AdcashBuzzvil />} />
          <Route path="/adcash/guru/nam/app" element={<AdcashGuruNAMApp />} />
          <Route path="/adcash/guru/nam/web" element={<AdcashGuruNAMWeb />} />
          <Route path="/adcash/guru/adforus" element={<AdcashGuruAdforus />} />
          <Route path="/adcash/guru/targetpick" element={<AdcashGuruTargetPick />} />
          <Route path="/adcash/guru/covi" element={<AdcashGuruCovi />} />
          <Route path="/adcash/avatye/revenue" element={<AdcashAvatyeRevenue />} />
          <Route path="/adcash/avatye/detail" element={<AdcashAvatyeDetail />} />
          <Route path="/adcash/adfit" element={<Adfit />} />
          <Route path="/naver/revenue" element={<NaverProviderRevenue />} />
          <Route path="/naver/direct/daily" element={<NaverDirectDetailStats />} />
          <Route path="/naver/hourly/spent" element={<NaverSpentStats />} />
          <Route path="/naver/direct/realtime" element={<NaverDirectRealtimeStats />} />
          <Route path="/naver/news/revenue" element={<NewsRevenue />} />
          <Route path="/naver/news/magazine/detail" element={<NewsMagazineStats />} />
          <Route path="/naver/news/direct/realtime" element={<NewsDirectRealtimeStats />} />

          <Route path="/roulette/chart" element={<RouletteChart />} />

          {/* 럭키복권 */}
          <Route path="/lucky-lottery/ticket/received" element={<TicketReceived />} />
          <Route
            path="/lucky-lottery/ticket/received/contents"
            element={<ContentsParticipation />}
          />
          <Route path="/lucky-lottery/ticket/received/attendance" element={<AttendanceCheck />} />
          <Route path="/lucky-lottery/enter" element={<EnterCount />} />
          <Route path="/lucky-lottery/exchange/currency" element={<LuckyLotteryExchange />} />
          <Route path="/lucky-lottery/exchange/npay" element={<LuckyLotteryNpayExchange />} />
          <Route path="/lucky-lottery/adpopcorn" element={<LuckyLotteryAdPopcorn />} />
          <Route path="/lucky-lottery/adpopcorn/detail" element={<LuckyLotteryAdPopcornDetail />} />
          <Route path="/lucky-lottery/revenue" element={<LuckyLotteryRevenue />} />
          <Route path="/lucky-lottery/revenue/detail" element={<LuckyLotteryRevenueDetail />} />
          <Route
            path="/lucky-lottery/settlement/status"
            element={<LuckyLotterySettlementStatus />}
          />
          <Route path="/lucky-lottery/buzzvil" element={<LuckyLotteryBuzzvil />} />
          <Route path="/lucky-lottery/retention" element={<LuckyLotteryRetention />} />
          <Route path="/lucky-lottery/winning" element={<LuckyLotteryWinning />} />
        </Routes>
      </Box>

      <Footer />
    </Box>
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          html: {
            height: '100%',
          },
          body: {
            height: '100%',
            margin: 0,
            overflow: 'auto',
          },
          '#root': {
            minHeight: '100%',
          },
        }}
      />

      <Routes>
        {isProd && <Route path="/login" element={<LoginWithMS />} />}
        {isProd && <Route path="/login/guest" element={<LoginGuest />} />}
        <Route
          path="*"
          element={isProd ? <ProtectedRoute>{mainLayout}</ProtectedRoute> : mainLayout}
        />
      </Routes>
    </ThemeProvider>
  );
}
